'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('TrainListCtrl', TrainListCtrl).directive('msTrainList', msTrainList);

  function msTrainList() {
    return {
      restrict: 'AE',
      templateUrl: 'vnext/templates/trainList.html',
      controller: 'TrainListCtrl',
      controllerAs: 'vm',
      scope: {}
    };
  }

  TrainListCtrl.$inject = ['$log', 'trainSvc', 'activityRouter'];

  function TrainListCtrl($log, trainSvc, activityRouter) {
    var vm = this;
    vm.skipTo = activityRouter.skipToActivity;
    trainSvc.getTrain().then(function (train) {
      vm.activities = train.activities;
    });
  }
})();